import { Forms } from "~/utils/products";

export const initialFormData = {
  category: {
    [Forms.BANK]: true,
    [Forms.REALESTATE]: true,
    [Forms.PENSION]: true,
    [Forms.CRYPTO]: true,
    [Forms.SHARE]: true,
    [Forms.DEBT]: true,
    [Forms.OTHER]: true,
    [Forms.RSU]: true,
  },
  column: {
    name: true,
    accountNumber: false,
    baseCurrency: true,
    originalCurrency: false,
    currentYield: true,
    yieldFromStartOfActivity: false,
    ownership: false,
    expectedYield: false,
    liquidity: false,
    profit: true,
    managementFee: false,
    partOfPortfolio: false,
    // monthlyChange: true,
    // dailyChange: true,
    expectedMonthlyGrowth: false,
    lastUpdateDate: true,
    filterBy: false,
  },
};
